import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { FiUser, FiLock, FiPhone } from 'react-icons/fi';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Foydalanuvchi nomi va parolni kiriting");
      return;
    }
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Muvaffaqiyatli kirdingiz!");
    } catch (err) {
      toast.error(err.response?.data?.error || "Kirish xatosi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.bgPattern} />
      <div style={styles.container}>
        <div style={styles.logoSection}>
          <div style={styles.logoIcon}><FiPhone size={28} /></div>
          <h1 style={styles.companyName}>AUD-IT SOFT</h1>
          <p style={styles.subtitle}>Qo'ng'iroqlar Markazi</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <h2 style={styles.formTitle}>Tizimga kirish</h2>

          <div className="input-group">
            <label>Foydalanuvchi nomi</label>
            <div style={styles.inputWrap}>
              <FiUser style={styles.inputIcon} />
              <input
                className="input"
                style={styles.inputPadded}
                type="text"
                placeholder="admin"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoFocus
              />
            </div>
          </div>

          <div className="input-group">
            <label>Parol</label>
            <div style={styles.inputWrap}>
              <FiLock style={styles.inputIcon} />
              <input
                className="input"
                style={styles.inputPadded}
                type="password"
                placeholder="••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{ width: '100%', justifyContent: 'center', padding: '12px', fontSize: '15px', marginTop: '8px' }}>
            {loading ? 'Kirish...' : 'Kirish'}
          </button>
        </form>

        <p style={styles.footer}>&copy; 2024 "AUD-IT SOFT" MCHJ. Barcha huquqlar himoyalangan.</p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0c1425 0%, #162032 50%, #1a1a3e 100%)',
    position: 'relative',
    overflow: 'hidden',
  },
  bgPattern: {
    position: 'absolute', inset: 0, opacity: 0.04,
    backgroundImage: `radial-gradient(circle at 25% 25%, #3b82f6 1px, transparent 1px),
                       radial-gradient(circle at 75% 75%, #3b82f6 1px, transparent 1px)`,
    backgroundSize: '50px 50px',
  },
  container: {
    position: 'relative', zIndex: 1,
    width: '100%', maxWidth: '420px', padding: '20px',
  },
  logoSection: {
    textAlign: 'center', marginBottom: '32px',
  },
  logoIcon: {
    width: '60px', height: '60px',
    background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
    borderRadius: '16px',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    color: 'white', marginBottom: '16px',
    boxShadow: '0 8px 32px rgba(59, 130, 246, 0.3)',
  },
  companyName: {
    fontSize: '24px', fontWeight: '800',
    letterSpacing: '-0.02em', color: '#f1f5f9',
  },
  subtitle: {
    fontSize: '14px', color: '#64748b', marginTop: '4px',
    letterSpacing: '0.08em', textTransform: 'uppercase',
  },
  form: {
    background: '#1e293b',
    border: '1px solid #2d3a4f',
    borderRadius: '20px',
    padding: '32px',
    display: 'flex', flexDirection: 'column', gap: '20px',
    boxShadow: '0 8px 40px rgba(0,0,0,0.3)',
  },
  formTitle: {
    fontSize: '18px', fontWeight: '700',
    textAlign: 'center', color: '#f1f5f9',
    marginBottom: '4px',
  },
  inputWrap: { position: 'relative' },
  inputIcon: {
    position: 'absolute', left: '14px', top: '50%',
    transform: 'translateY(-50%)',
    color: '#64748b', fontSize: '16px',
  },
  inputPadded: { paddingLeft: '42px' },
  footer: {
    textAlign: 'center', fontSize: '12px',
    color: '#475569', marginTop: '24px',
  },
};
